import gqlValidateCampaignReferral from 'services/api/advocacy/validateCampaignReferral';
import gqlAddToPromotion from 'services/api/advocacy/addToPromotion';
import utilityApi from 'services/api/utility';

// Killswitch gates both the new UI and GraphQL transport atomically; function form picks up runtime flips.
const isGraphQLEnabled = () => Sephora.configurationSettings.refereeLandingPageEnhancements?.isEnabled === true;

const advocacyApi = {
    validateCampaignReferral: payload =>
        isGraphQLEnabled() ? gqlValidateCampaignReferral(payload) : utilityApi.getAdvocacyLandingPageContentSDN(payload),
    addToPromotion: (payload, referralToken) =>
        isGraphQLEnabled() ? gqlAddToPromotion(payload, referralToken) : utilityApi.addToPromotion(payload, referralToken)
};

export default advocacyApi;
